import { DiscoSideBarItem, DiscoSideBarItemProps } from "@disco-ui"

type AdminSidebarItemProps = DiscoSideBarItemProps

function AdminSidebarItem(props: AdminSidebarItemProps) {
  return <DiscoSideBarItem indentNestedItems {...props} />
}

export default AdminSidebarItem
